export const prpcowConnectionKey =
	window.APP_CONFIG?.PRPCOW_CONNECTION_KEY ||
	process?.env?.REACT_APP_PRPCOW_CONNECTION_KEY;
export const baseHost =
	window.APP_CONFIG?.BASE_HOST || process?.env?.REACT_APP_BASE_HOST;
export const baseSocket =
	window.APP_CONFIG?.BASE_SOCKET_HOST ||
	process?.env?.REACT_APP_BASE_SOCKET_HOST;

// * === Developer/Test Sockets ===
// export const baseSocket = process?.env?.REACT_APP_BASE_SOCKET_HOST;
// export const baseSocket = "wss://api.development.demo.express-soft.org/";
// export const baseSocket = "wss://api.demo.express-soft.org/"; // ? Demo environment
// export const baseSocket = "wss://api.beta.demo.express-soft.org/"; // ? Beta demo environment

// * === Local/Custom Sockets ===
// export const baseSocket = "ws://localhost:9092/"; // ? Local development
// export const baseSocket = "wss://c22d-185-67-252-124.ngrok-free.app"; // ? Temporary ngrok tunnel

// * === Production/Project Sockets ===
// export const baseSocket = "wss://api.express-t.express-soft.org/"; // ? express-t project
// export const baseSocket = "wss://api.b2b-urban.express-soft.org/"; // ? b2b-urban project
// export const baseSocket = "wss://api.taxi571.express-soft.org/"; // ? taxi571 project
// export const baseSocket = "wss://api.taxi.999.md";  // ? 999.md project
// export const baseSocket = "wss://api.cabinet.express-partner-pl.com";
// export const baseSocket = "wss://api.cabinet.taxi-simka.com";
// export const baseSocket = "wss://api.cabinet-45.express-soft.org/";
// export const baseSocket = "wss://api.chveni.taxi/";
// export const baseSocket = "wss://api.triyka.express-soft.org";
// export const baseSocket = "wss://api.cabinet-21.express-soft.org";
// export const baseSocket = "wss://api.cabinet-18.express-soft.org";
